import React, { useState, useRef, useEffect } from 'react';

const useImgLoader = src => {
  let [loadedState, setLoadedState] = useState(0);

  const mounted = useRef(true);

  useEffect(() => () => { mounted.current = false }, []);

  useEffect(() => {
    setLoadedState(0);

    if (!src) {
      return;
    }

    const img = new window['Image']();
    img.src = src;

    let loaded = false;

    img.onload = () => {
      loaded = true;
      mounted.current && setLoadedState(2);
    };

    img.onerror = (e) => {
      window.console.log(e)
      window.console.log("error loading image")
    }

    setTimeout(() => {
      if (loaded) return;
      mounted.current && setLoadedState(1);
    }, 300);
  }, [src]);

  return loadedState;
};

export default useImgLoader;
